import classNames from 'classnames'

import Button from '../Button'

import * as styles from './Outlined.module.css'

function Outlined({ className, isActive, isGrey, isSkeleton, ...restProps }) {
  const buttonClassName = classNames(
    styles.outlined,
    { [styles.basic]: !isGrey },
    { [styles.grey]: isGrey },
    { [styles.active]: isActive },
    { [styles.skeleton]: isSkeleton },
    className
  )

  return (
    <Button
      {...restProps}
      className={buttonClassName}
      isActive={isActive}
      isSkeleton={isSkeleton}
    />
  )
}

export default Outlined
